import { useState } from "react";
import SplashScreen from "./components/SplashScreen.jsx";
import AppIndex from "./App.jsx"; // your main app content

function App() {
  const [showSplash, setShowSplash] = useState(true);

  if (showSplash) {
    return <SplashScreen onFinish={() => setShowSplash(false)} />;
  }

  return <AppIndex />;
}

export default App;